import alert from '@/plugins/alert'
import { Attendance } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    attendances: {},
    count: 0,
  },
  actions: {
    async fetchAttendances({ commit }, options) {
      commit(
        'setAttendances',
        await Attendance.fetch({
          ...options,
          _limit: -1,
          _sort: 'updatedAt:desc',
        })
      )
    },
    async countAttendances({ commit }, options) {
      commit('setCount', await Attendance.count(options))
    },
    async fetchAttendance({ commit }, attendanceId) {
      commit('setAttendance', await Attendance.fetchOne(attendanceId))
    },
    // api is create or update. If record exist then create.
    async createAttendance({ commit }, { data, options }) {
      commit('setAttendance', await Attendance.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeAttendance({ commit }, id) {
      await Attendance.remove(id)
      commit('removeAttendance', id)
      alert.success('Xóa thành công!')
    },
    setAttendance({ commit, state }, attendance) {
      commit('setAttendance', attendance)
    },
    async removeAttendances({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeAttendance', item.id)
      }
    },
    async updateAttendances({ dispatch }, items) {
      await Promise.all(
        items.map((item) => dispatch('createAttendance', { data: item }))
      )
    },
  },
  mutations: {
    setAttendances(state, attendances) {
      state.attendances = attendances.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue,
        }),
        {}
      )
    },
    setAttendance(state, attendance) {
      state.attendances = {
        ...state.attendances,
        [attendance.id]: attendance,
      }
    },
    removeAttendance(state, attendanceId) {
      delete state.attendances[attendanceId]
      state.attendances = { ...state.attendances }
    },
    setCount(state, count) {
      state.count = count
    },
  },
  getters: {
    attendances: (state) => {
      return Object.values(state.attendances)
    },
    attendance: (state) => (id) => {
      return state.attendances[id]
    },
    count: (state) => {
      return state.count
    },
  },
}
